import store from "@/store/index";

export interface AppCoachMatchesCategoriesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    fields: any;
  };
}

export class AppCoachMatchesCategoriesListFormCreate implements AppCoachMatchesCategoriesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    fields: any;
  };

  constructor() {
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.content = {
      name: "",
      fields: [],
    };
  }
}